module.exports = ".ck.ck-label{display:block}.ck.ck-voice-label{display:none}.ck.ck-label{font-weight:700}"


// WEBPACK FOOTER //
// webpack://ClassicEditor/ckeditor5-ui/theme/components/label/label.css